import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function SectionLabel({
  children,
  tone = 'dark'
}: SectionLabelProps) {
  return <div className={`flex items-center gap-3 text-[11px] font-medium uppercase tracking-wider-xl ${tone === 'dark' ? 'text-forest-soft' : 'text-gold-soft'}`} data-id="element-290" data-mp="2yet2f4dmz4lz">
      <span className={`h-px w-8 ${tone === 'dark' ? 'bg-gold' : 'bg-gold/70'}`} aria-hidden="true" data-id="element-291" data-mp="33bjezhq8fi2n" />
      {children}
    </div>;
}